import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function CarAccidents() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Car Accidents</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
            <div className="pi-text">
                <p>Many insurance companies expect car accident victims to accept the amount they offer simply.
And without a lawyer on your side, the insurance company generally has the advantage. Very
often, they blame you in an attempt to give you a small fraction of the money you are entitled to.<br/><br/>
Our Team can help. We will take on the insurance companies and protect what is in your best
interests. Our seasoned team not only has the experience needed to get you the maximum
compensation, but we also have the resources. We utilize our team of experts, which includes
accident reconstructionists, medical professionals, and financial specialists, who aid us in
demonstrating how the accident happened, who was at fault, and what the true extent of your
past and future losses are, including but not limited to lost wages, medical bills, and, pain &
suffering.<br/><br/>
With hundreds of car accidents happening all across southern Ontario, it’s easy to forget the
people who have been injured in such car accidents. At CLV, we strongly believe that there is
nothing more important than your health. If you or a loved one has been in a <b>car/motor vehicle
accident</b>, trust the personal injury lawyer services of CLV to guide you through this difficult time.<br/><br/>
<span className="pi-sub-section">Common Causes of Car Accidents</span><br/><br/>
We have successfully represented drivers, passengers, and pedestrians that were injured due
to:
<ul>
<li> Texting while driving </li>
<li> Dangerous lane changes or failure to yield the right of way</li>
<li> Driving at unsafe speeds</li>
<li> Failure to pay attention to changing road conditions</li>
<li> Unsafe or improper turns</li>
<li>Failure to obey traffic signs</li>
</ul>
<span className="pi-sub-section">Car Accident Insurance Claims in Ontario</span><br/><br/>
Since Ontario limits the right to sue for damages following a car accident, <b>car accident claims
in Ontario </b>are what most personal injury lawyers deal with. For people who have been involved
in a car accident, insurance claims are the primary avenue for receiving compensation. In
Ontario, claimants are entitled to some mandatory benefits.<br/><br/>
There are two types of compensation that can be received from insurers.
<ul>
<li> Accident Benefits: These are mandatory benefits that insurers have to pay to injured
individuals, including those who are considered at-fault. Car accident liabilities or faults
do not invalidate these benefits.</li>
<li> Damages: For people with physical or psychological injuries that meet certain criteria,
insurers may have to pay compensation for damages. This is referred to as a tort claim,
and car accident liabilities in Toronto or Ontario may have an impact on compensation.</li>
</ul>

When people involved in car accidents file a claim, they may find that their insurer denies the
claim and refuses to provide benefits or damages. A car accident lawyer in Ontario can
represent an injured client, ensuring that they receive the benefits they are entitled to. Often, a
car accident settlement in Ontario can be reached by a professional personal injury lawyer who
understands Ontario legislation and the duties of the insurer.<br/><br/>
<span className="pi-sub-section">Car Accident Liabilities</span><br/><br/>
In Ontario, legislation limits the actions that injured individuals can take against negligent
drivers. However, <b>car accident liabilities and faults </b>can still have a large impact on the
amount of compensation received. In order to receive compensation from a tort claim, it can be
necessary to prove that another party was at fault.<br/><br/>
Following a car accident, it is important to immediately <Link to="/our-team/mick-vashishth">contact a personal injury lawyer</Link> who can
advise on legal options and recommend important steps to take. With the services of
an <b>experienced personal injury team</b>, a car accident insurance claim in Toronto can secure
the maximum amount of compensation.<br/><br/>
<span className="pi-sub-section">What To Do in A Car Accident?</span><br/><br/>
If you are ever in a <b>car, motor vehicle accident</b>, it is important that you document the nature
and extent of your motor vehicle accident and personal injuries. This includes name, telephone
number, and insurance information of all the parties involved, informing the Police or the
Collision Reporting Centre of your accident, and taking photographs of the damage to your call
and any other vehicles involved. You may also want to take pictures of your own injuries.<br/><br/>
To arrange a Free consultation, <Link to="/contact-us">contact us</Link> today.</p>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
        </div>
            <Footer />
        </>
        );
}